exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.petinfo .vux-no-group-title {\n  margin-top: 0 !important;\n  width: 230px !important;\n}\n.petinfo .weui-cells:before,\n.weui-cells:after {\n  display: none;\n}\n.petinfo .vux-cell-box:not(:first-child):before {\n  display: none;\n}\n.petinfo .weui-cell {\n  padding: 0 !important;\n  width: 230px;\n}\n.dp-header .dp-item.dp-right,\n.vux-popup-header-right {\n  color: #ea5858 !important;\n}\n", ""]);

// exports
